import { CategoriesEnum } from 'src/enums';

export const pcBuildReq = [
  CategoriesEnum.Motherboard,
  CategoriesEnum.CPU,
  CategoriesEnum.PSU,
  CategoriesEnum.Casing,
  CategoriesEnum.RAM
];
